module.exports = __webpack_public_path__ + "static/img/biasfx2-rack-view-2.53e8b44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/biasfx2-rack-view-2.jpg
// module id = FTPj
// module chunks = 12